import { ERROR_CODES } from './ErrorCodes'
import { GenericException } from './GenericException'

export class MissingEnvVariableException extends GenericException {
  constructor(missingEnvVariables: string[] | string) {
    super({
      ...ERROR_CODES.MISSING_ENV_VARIABLE,
      developerMessage: `Missing environment variable(s): ${
        Array.isArray(missingEnvVariables) ? missingEnvVariables.join(', ') : missingEnvVariables
      }`,
    })
  }
}
